import { Box } from '@mui/material'
import { FC } from 'react'
import Level from './Level'
import { StyledLevelWrapper } from './styles'
import { LevelSelectorProps } from './types'

const LevelSelectorDesktop: FC<LevelSelectorProps> = ({
  selectedIndex,
  evTrainingLevels,
  onChange,
}) => {
  return (
    <Box mb={4} pt={4} display="flex" style={{}}>
      <StyledLevelWrapper>
        {evTrainingLevels.map((evTrainingLevel, index) => {
          return (
            <Level
              key={evTrainingLevel.levelUUID}
              iconName={evTrainingLevel.iconName}
              alt={evTrainingLevel.name}
              onClick={() => onChange(index)}
              selected={selectedIndex === index}
              label={evTrainingLevel.name}
              status={evTrainingLevel.status}
              isAvailable={evTrainingLevel.isAvailable}
              isLocked={evTrainingLevel.isLocked}
              expiryDate={evTrainingLevel.expiryDate}
              isExpired={evTrainingLevel.isExpired}
              isHookman={evTrainingLevel.isHookman}
              isDueForRecertification={evTrainingLevel.isDueForRecertification}
            />
          )
        })}
      </StyledLevelWrapper>
    </Box>
  )
}

export default LevelSelectorDesktop
